import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import { MutationCompleteTaskArgs } from '@api/generated/graphql';
import extractErrorMessage from '@lib/utils/extractErrorMessage';

export const COMPLETE_TASK_MUTATION = graphql(`
  mutation CompleteTask(
    $taskId: ID!
    $tenantId: ID!
    $input: TaskCompleteInput!
  ) {
    completeTask(taskId: $taskId, tenantId: $tenantId, input: $input)
  }
`);

export const completeTask = async (
  variables: MutationCompleteTaskArgs,
): Promise<boolean> => {
  try {
    const { data } = await getClient().mutate({
      mutation: COMPLETE_TASK_MUTATION,
      variables,
    });

    if (!data?.completeTask) {
      throw new Error('Failed to complete speed to lead task');
    }

    return data.completeTask;
  } catch (err) {
    throw new Error(extractErrorMessage(err));
  }
};
